import React from 'react';


import {ProfileMain} from 'src/components/profile-tab-structure';
import {CheckboxSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';

export const SsoTabSkeleton = () => (
    <ProfileMain header={(
        <Item grow={1}>
            <Group justify="space-between">
                <SkeletonItem width={190} height={28}/>

                <Group>
                    <SkeletonItem width={134} height={32}/>
                    <SkeletonItem width={115} height={32}/>
                </Group>
            </Group>
        </Item>
    )}>
        <FormSectionSkeleton labelWidth={345}>
            <Group direction="v" alignItems="start">
                <CheckboxSkeleton labelWidth={92}/>
                <CheckboxSkeleton labelWidth={100}/>
                <SkeletonItem width={650} height={32}/>
                <SkeletonItem width={650} height={400}/>
                <SkeletonItem width={650} height={32}/>
            </Group>
        </FormSectionSkeleton>
        <FormSectionSkeleton labelWidth={238}>
            <Group direction="v" alignItems="start">
                <CheckboxSkeleton labelWidth={148}/>
            </Group>
        </FormSectionSkeleton>
    </ProfileMain>
);
